// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// const firebaseConfig = {
//   apiKey: "AIzaSyAR7DiLYzBZ4sfVVUvmwqCtry2NDa5hKn0",
//   authDomain: "dcis-d1ee5.firebaseapp.com",
//   databaseURL: "https://dcis-d1ee5-default-rtdb.firebaseio.com",
//   projectId: "dcis-d1ee5",
//   storageBucket: "dcis-d1ee5.appspot.com",
//   messagingSenderId: "274644190088",
//   appId: "1:274644190088:web:6afd7dd232937e6ff0b03d",
//   measurementId: "G-077Y1C8R4T",
// };


const firebaseConfig = {

  apiKey: "AIzaSyCn9xidGyTPnGP1jbJb23Q8XJBK9adWKiY",

  authDomain: "dcis-development-367507.firebaseapp.com",

  databaseURL: "https://dcis-development-367507-default-rtdb.firebaseio.com",

  projectId: "dcis-development-367507",

  storageBucket: "dcis-development-367507.appspot.com",

  messagingSenderId: "264807686722",

  appId: "1:264807686722:web:f6921c58fc7229837183db",

  measurementId: "G-2CLFFLXFNL"

};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);
